import { useEffect, useRef, useState } from "react";
import BreadCrumbs from "../../components/General/BreadCrumbs";
import LoadingSkeleton from "../../components/UI/LoadingSkeleton";
import { getArticles } from "../../utils/fetcher";
import FindVehicleFilter from "../../components/Vehicles/FindVehicleFilter";
import SidebarBox from "../../components/General/SidebarBox";
import LatestNews from "../../components/News/LatestNews";
import style from "./index.module.css";
import { useScrollToTop } from "../../utils/generalUtils";
import { useTranslation } from "../../hooks/useTranslation";

const News = () => {
  const { locale } = useTranslation();

  const initialMount = useRef<boolean>(true);

  useScrollToTop();

  const [componentData, setComponentData] = useState<{
    isFetching: boolean;
    data: {
      news: any;
    };
  }>({
    isFetching: true,
    data: {
      news: null,
    },
  });

  useEffect(() => {
    if (!initialMount.current) {
      setComponentData((current) => ({
        ...current,
        isFetching: true,
      }));
    }
    initialMount.current = false;
    let data: any = {
      news: null,
    };
    (async () => {
      await getArticles("?number=10")
        .then((res) => {
          data.news = res.data.articles;
        })
        .catch((error) => {});
      setComponentData({
        isFetching: false,
        data,
      });
    })();
  }, []);

  return (
    <>
      {/* <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <BreadCrumbs
              pages={[
                { text: locale("home"), link: "/" },
                {
                  text: locale("news"),
                  link: "",
                },
              ]}
            />
          </div>
        </div>
      </div> */}
      <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <div className={`${style.page_row} row`}>
              <div className="col-lg-4">
                <SidebarBox>
                  <FindVehicleFilter vehicleNames={{ single: "bus", plural: "buses" }} vehicleCondition="new" />
                </SidebarBox>
              </div>
              <div className="col-lg-8">
                {((componentData.data.news && !componentData.isFetching) || componentData.isFetching) && (
                  <>
                    <h3 className="main_section__title main_section__title--center">{locale("news")}</h3>
                    <div className={style.all_news}>
                      {componentData.isFetching ? (
                        <LoadingSkeleton count={5} />
                      ) : (
                        componentData.data.news.map((article: any) => (
                          <div key={article.id} className={style.single_news}>
                            <LatestNews {...article} />
                          </div>
                        ))
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default News;
